import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#4f604c',
                secondary: '#db917c',
            },
            dark: {
                primary: '#CF8F88',
                secondary: '#4f604c',
                error: '#bd0000',
            },
        },
        dark: true,
    },
});
